import {
    BaseInfiltrationCalculationOption,
    BaseInfiltrationMethod,
    WasteWaterBaseInfiltration,
} from 'app/shared/models/sliicer/customer-rainfall-profile';

export type BaseInfiltrationValue = {
    method: BaseInfiltrationMethod;
    constant: number;
};

export type State = {
    infiltrationType: BaseInfiltrationCalculationOption;
    savedBaseInfiltration: WasteWaterBaseInfiltration;
    method: BaseInfiltrationMethod;
    constant: number;
};

export function initState(data: WasteWaterBaseInfiltration): State {
    if (data !== null && data !== undefined) {
        return {
            infiltrationType: data.infiltrationType,
            savedBaseInfiltration: { ...data },
            method: data.method,
            constant: data.method === BaseInfiltrationMethod.StevensSchutzbach ? null : data.constant,
        };
    } else {
        return {
            infiltrationType: BaseInfiltrationCalculationOption.Gross,
            savedBaseInfiltration: null,
            method: BaseInfiltrationMethod.StevensSchutzbach,
            constant: null,
        };
    }
}

export const constantChanged: (constant: number) => (state: State) => State = (constant) => (state) => ({
    ...state,
    constant: constant,
});

export const toResult = (state: State): WasteWaterBaseInfiltration => ({
    infiltrationType: state.infiltrationType,
    method: state.method,
    constant: state.constant ? state.constant : 0,
});
